<template>
  <div v-if="show" class="age-confirm-modal">
    <div class="age-confirm-modal-background">

    </div>
    <div class="age-confirm-modal-body">
      <div class="age-confirm-modal-body-content">
        <div class="age-confirm-modal-body-content-headline">
          {{trans('age_modal.age_check')}}
        </div>
        <div class="age-confirm-modal-body-content-text">
          <p>{{trans('age_modal.contain_sensitive_material')}}</p>
          <p>{{trans('age_modal.you_need_eighteen')}}</p>
        </div>
      </div>
      <div class="age-confirm-modal-body-footer">
        <i18n path="reg.accept_terms_privacy_text" tag="div" class="input-title">
          <a class="color-green" @click="showPagePopup('privacy')">{{ trans('reg.privacy_policy') }}</a>
          <a class="color-green" @click="showPagePopup('terms')">{{ trans('reg.terms_of_use') }}</a>
        </i18n>
        <button @click="confirmAge" class="btn btn-primary btn-rounded button-create-account">{{trans('reg.next')}}</button>
        <button @click="leaveDiscover" class="btn btn-rounded btn-default button-login">{{trans('leave')}}</button>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapActions, mapState} from 'vuex'

export default {
  props: [],
  mixins: [
    require('@general/lib/mixin').default
  ],
  computed: {
    ...mapGetters({
    }),
    ...mapState({
      show: state => state.modal.age_confirm,
    })
  },
  methods: {
    ...mapActions([
    ]),
    showPagePopup(page) {
      //app.showLightLoading(true);

      let title = page == 'terms' ? this.trans('reg.terms_of_use') : this.trans('reg.privacy_policy');

      axios.get('/api/getStaticPage/'+app.lang+'/'+page)
          .then(({data}) => {
            this.showErrorNotification(data.content);
            //app.showLightLoading(false);
          })
          .catch(e => {
            //app.showLightLoading(false);
          })
    },
    leaveDiscover : function (){
      location.href = '/';
    },
    confirmAge: function(){
      localStorage.setItem('age_confirmed', 1);
      let self = this;
      if(!localStorage.getItem('location')){
        axios.post('/api/register/find-location').then(response => {
          //all is good, no need to do anything
        }).catch((e) => {
          self.$store.dispatch('requirementsAlertShow', 'location')
        })
      }
      this.closeAgeConfirmModal();
    }
  },
  data() {
    return {
    }
  }
}
</script>
